module.exports = __webpack_public_path__ + "static/seat-83fb391a83759b3cb28b7e0f1c0d250d.webp";